const JaaGaDetails = () => {
  return (
    // <section> + aria-label so screen-readers announce the landmark as
    // "JaaGa key statistics" instead of an unnamed region. Each stat uses
    // <dl>/<dt>/<dd>, the semantically correct shape for term/value pairs.
    // Numbers are the term, labels are the description. The visual styling
    // (jh-stat-num / jh-stat-label) stays on dt/dd so existing CSS still
    // applies. h2 is visually hidden via .sr-only-equivalent inline style
    // so crawlers see a heading for the section without changing the look.
    <section className="jh-stats-strip" aria-label="JaaGa key statistics">
      <div className="jh-wrap">
        <h2
          style={{
            position: "absolute",
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0,0,0,0)",
            whiteSpace: "nowrap",
            border: 0,
          }}
        >
          JaaGa by the numbers
        </h2>
        <dl className="jh-stats-inner">
          <div className="jh-stat">
            <dt className="jh-stat-num">2.5 Billion+</dt>
            <dd className="jh-stat-label">Data Records</dd>
          </div>
          <div className="jh-stat">
            <dt className="jh-stat-num">10,000+</dt>
            <dd className="jh-stat-label">Audit Reports Delivered</dd>
          </div>
          <div className="jh-stat">
            <dt className="jh-stat-num">1 Million+</dt>
            <dd className="jh-stat-label">Document Searches</dd>
          </div>
          <div className="jh-stat">
            <dt className="jh-stat-num">140+</dt>
            <dd className="jh-stat-label">Instant Documents Available</dd>
          </div>
        </dl>
      </div>
    </section>
  );
};

export default JaaGaDetails;
